import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const SolutionContext = React.createContext({
  hasSolution: false,
  solutionShown: 0
});
export const SolutionContextProvider = _ref => {
  let {
    children,
    context
  } = _ref;
  return ___EmotionJSX(SolutionContext.Provider, {
    value: context
  }, children);
};